import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useProducts from "../../../hooks/context/useProducts";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import { amber, grey } from "@mui/material/colors";
import { useBRLmoney } from "../../../hooks/useBRLmoney";
import {
  CarrouselWith4cards,
  CustomButton,
} from "../../../components/AtomicDesign/Molecules";
import useToast from "../../../hooks/context/useToast";
import {
  CustomBreadcrumbs,
  DataText,
  FadeInContainer,
  NoData,
} from "../../../components/AtomicDesign/Atoms";
import RareIcon from "../../../assets/images/coelho/raro-icon.svg";
import { addFavorite, removeFavorite } from "../../../services/userServices";
import useAuth from "../../../hooks/context/useAuth";
import useGlobalLoading from "../../../hooks/context/useGlobalLoading";
import useCart from "../../../hooks/context/useCart";
import { colors } from "../../../theme/colors";

export function Details() {
  const { setOpenLoading } = useGlobalLoading();
  const nav = useNavigate();
  const { user } = useAuth();
  const [params] = useSearchParams();
  const productID = params.get("product");
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const { setOpen, setToastData } = useToast();
  const { addToMyCart } = useCart();
  const { setHandleIDProduct, product, getOneProduct } = useProducts();
  const { BRLmoney } = useBRLmoney();
  const [imageIndex, setImageIndex] = useState(0);
  const [selectedQTD, setSelectedQTD] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [product?.id]);

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "success",
        message: "Link copiado",
      });
      setOpen(true);
    } catch {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "success",
        message: "error",
      });
      setOpen(true);
    }
  };

  useEffect(() => {
    if (productID) {
      setHandleIDProduct(Number(productID));
    }
    // eslint-disable-next-line
  }, [productID]);

  const maxWidth = isMobile ? "95%" : 500;
  const cardsWidth = isSmalldesktop ? "75%" : "58%";

  const removeFav = async () => {
    setOpenLoading(true);
    try {
      await removeFavorite({ productID: product?.id, userID: user?.user?.id });
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "success",
        message: "Favorite removed",
      });
      getOneProduct(false);
    } catch {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "error",
        message: "Error while removing the favorite, try again",
      });
    } finally {
      // setTimeout(() => setOpenLoading(false), 5000);
      setOpenLoading(false);
    }
  };

  const addFav = async () => {
    setOpenLoading(true);
    try {
      await addFavorite({ productID: product?.id, userID: user?.user?.id });
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "success",
        message: "Favorite add to your list",
      });
      getOneProduct(false);
    } catch {
      setToastData({
        anchor: { vertical: "top", horizontal: "center" },
        duration: 5000,
        type: "error",
        message: "Error while add the favorite to your list, try again",
      });
    } finally {
      // setTimeout(() => setOpenLoading(false), 5000);
      setOpenLoading(false);
    }
  };

  const addToCart = async () => {
    if (!user) {
      nav("/user/login");
    } else {
      await addToMyCart(
        {
          cartID: user?.cartID,
          productID: product?.id,
          quantity: selectedQTD,
        },
        true
      );
    }
  };

  return (
    <Box display={"flex"} justifyContent={"center"} width={"100%"}>
      <Paper
        elevation={3}
        sx={{
          mt: 10,
          display: "flex",
          justifyContent: "center",
          width: "90%",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <FadeInContainer>
          <CustomBreadcrumbs
            config={{
              sx: {
                display: "flex",
                width: "100%",
                mb: 3,
                p: isMobile ? 1 : 5,
              },
            }}
            crumbs={[
              { crumbName: "Home", path: "/" },
              { crumbName: "Produtos", path: "/products?tab=1" },
              {
                crumbName: "Detalhes do produto",
                path: `details?product=${product?.id}`,
              },
            ]}
          />
          <Box
            display={"flex"}
            justifyContent={"center"}
            width={"100%"}
            flexWrap={"wrap"}
          >
            {product?.id ? (
              <Box
                display={"flex"}
                justifyContent={"center"}
                width={"100%"}
                flexWrap={"wrap"}
                mb={4}
              >
                <Box
                  display={"flex"}
                  gap={2}
                  width={"100%"}
                  flexWrap={isSmalldesktop ? "wrap" : "nowrap"}
                  justifyContent={isSmalldesktop ? "center" : "space-between"}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    width={isSmalldesktop ? "100%" : "50%"}
                  >
                    {product?.isRare && (
                      <Box
                        style={{
                          position: "absolute",
                          zIndex: 500,
                          width: 70,
                          marginLeft: isMobile ? "80%" : 480,
                          marginTop: isMobile ? "-80%" : -650,
                          borderRadius: 5,
                          color: "#FFFFFF",
                          textAlign: "center",
                          transform: "rotate(20deg)",
                        }}
                      >
                        <img
                          src={RareIcon}
                          alt="icone de raro"
                          width={isMobile ? 70 : 100}
                        />
                      </Box>
                    )}
                    <img
                      src={`${product?.productsImages[imageIndex]?.code}`}
                      width={maxWidth}
                      height={maxWidth}
                      alt="figure"
                      style={{
                        objectFit: "contain",
                        borderRadius: 5,
                        background: grey[200],
                        marginBottom: 8,
                      }}
                    />

                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      maxWidth={maxWidth}
                      sx={{ overflowX: "auto", minHeight: 110 }}
                      gap={1}
                    >
                      {product?.productsImages?.map((image, index) => (
                        <img
                          key={index}
                          style={{
                            width: 100,
                            height: 100,
                            objectFit: "contain",
                            cursor: "pointer",
                            borderRadius: 5,
                            background: grey[200],
                            marginBottom: 6,
                          }}
                          src={image?.code}
                          alt={image?.code}
                          onMouseOver={() => {
                            setImageIndex(index);
                          }}
                          onClick={() => setImageIndex(index)}
                        />
                      ))}
                    </Box>
                  </Box>

                  <Box
                    width={isSmalldesktop ? "85%" : "50%"}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={1}
                  >
                    <Typography
                      fontSize={isSmalldesktop ? 18 : 28}
                      color={colors.purple[500]}
                      fontWeight={700}
                      style={{ wordBreak: "break-word" }}
                    >
                      {product?.name}
                    </Typography>
                    <Typography
                      fontSize={isSmalldesktop ? 14 : 16}
                      color={colors.gray[400]}
                      fontWeight={700}
                      style={{ wordBreak: "break-word" }}
                    >
                      {product?.versionName}
                    </Typography>
                    <Typography
                      fontSize={isSmalldesktop ? 14 : 16}
                      color={
                        product?.stock <= 0
                          ? colors.gray[400]
                          : colors.green[400]
                      }
                      fontWeight={700}
                      style={{ wordBreak: "break-word" }}
                    >
                      {product?.stock <= 0 ? "Fora de estoque" : "Em estoque"}
                    </Typography>
                    <Box height={24} display={"flex"} gap={1}>
                      {product?.stock <= 5 && product?.stock > 0 && (
                        <Typography
                          sx={{
                            fontSize: isMobile ? 12 : "16px",
                            fontWeight: 700,
                            textAlign: "left",
                            color: amber[400],
                            wordBreak: "break-word",
                          }}
                        >
                          Quase esgotando
                        </Typography>
                      )}
                      {product?.stock === 0 && (
                        <Typography
                          sx={{
                            fontSize: isMobile ? 12 : "16px",
                            fontWeight: 700,
                            textAlign: "left",
                            color: colors.red[400],
                            wordBreak: "break-word",
                          }}
                        >
                          Esgotado
                        </Typography>
                      )}
                      {product?.discountPrice > 0 && (
                        <Typography
                          sx={{
                            mt: isMobile ? 1 : 0,
                            fontSize: isMobile ? 12 : "16px",
                            fontWeight: 700,
                            textAlign: "left",
                            color: colors.green[400],
                          }}
                        >
                          Promoção
                        </Typography>
                      )}
                    </Box>
                    {product?.discountPrice > 0 ? (
                      <Box
                        display={"flex"}
                        flexWrap={"wrap"}
                        gap={isMobile ? 0 : 1}
                      >
                        <Typography
                          sx={{
                            fontSize: "29px",
                            fontWeight: 700,
                            textAlign: "left",
                            color: colors.green[400],
                          }}
                        >
                          {BRLmoney(product?.discountPrice)}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: 500,
                            textAlign: "left",
                            color: colors.textGrey[500],
                            textDecoration: "line-through",
                          }}
                        >
                          {BRLmoney(product?.price)}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "29px",
                          fontWeight: 500,
                          textAlign: "left",
                          color: colors.textGrey[500],
                        }}
                      >
                        {BRLmoney(product?.price)}
                      </Typography>
                    )}
                    <Box display={"flex"} alignItems={"center"}>
                      {product?.stock > 0 ? (
                        <Box display={"flex"} gap={2} mt={3}>
                          <Select
                            sx={{ width: 70 }}
                            value={selectedQTD}
                            defaultValue={1}
                            defaultChecked
                            onChange={(e) =>
                              setSelectedQTD(Number(e.target.value))
                            }
                          >
                            {Array.from(
                              {
                                length: product?.stock,
                              },
                              (_v, i) => i
                            ).map((qtd, index) => {
                              const removeZero = qtd + 1;
                              return (
                                <MenuItem value={removeZero} key={index}>
                                  {removeZero}
                                </MenuItem>
                              );
                            })}
                          </Select>

                          <Button
                            variant="contained"
                            style={{
                              borderRadius: 10,

                              fontSize: isSmalldesktop ? 12 : 14,
                            }}
                            onClick={addToCart}
                          >
                            <AddShoppingCartIcon sx={{ mr: 1 }} />
                            Adicionar ao carrinho
                          </Button>
                        </Box>
                      ) : (
                        <Typography
                          fontSize={20}
                          mt={1}
                          color={grey[500]}
                          maxWidth={500}
                        >
                          Desculpe, todo o estoque desse produto já foi vendido,
                          adicione aos favoritos para sabermos que você tem
                          interesse!
                        </Typography>
                      )}

                      <Typography mt={3} ml={2}>
                        <IconButton
                          onClick={() => {
                            if (product?.favorited) {
                              removeFav();
                            } else {
                              addFav();
                            }
                          }}
                        >
                          {product?.favorited ? (
                            <FavoriteIcon
                              style={{ fill: "red", fontSize: "30px" }}
                            />
                          ) : (
                            <FavoriteBorderIcon style={{ fontSize: "30px" }} />
                          )}
                        </IconButton>
                      </Typography>
                    </Box>
                    <CustomButton
                      btnType="share"
                      fullWidth={false}
                      style={{ width: 200, marginTop: 30 }}
                      onClick={() => copyContent()}
                    >
                      <ReplyAllIcon sx={{ mr: 1, ml: -2 }} /> Compartilhe
                    </CustomButton>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    mt: isSmalldesktop ? 3 : 0,
                  }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      p: isSmalldesktop ? 3 : 5,
                      mt: isSmalldesktop ? 0 : 5,
                      mb: 5,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignContent: "center",
                      gap: 3,
                      width: cardsWidth,
                    }}
                  >
                    <DataText
                      title={"Origem:"}
                      text={product?.originName}
                      containerProps={{ flexWrap: "wrap" }}
                      textProps={{
                        width: "100%",
                        sx: { wordBreak: "break-all" },
                      }}
                    />
                    <Divider sx={{ mt: -2 }} />
                    <DataText
                      title={"Versão:"}
                      text={product?.versionName}
                      containerProps={{ flexWrap: "wrap" }}
                      textProps={{
                        width: "100%",
                        sx: { wordBreak: "break-all" },
                      }}
                    />
                    <Divider sx={{ mt: -2 }} />

                    <DataText
                      html={product?.description}
                      title={"Descrição:"}
                      text={product?.description}
                      containerProps={{ flexWrap: "wrap" }}
                      textProps={{
                        width: "100%",
                        sx: { wordBreak: "break-all" },
                        overflow: "inherit",
                        maxHeight: "100%",
                      }}
                    />
                    <Divider sx={{ mt: -2 }} />

                    <Box
                      display={"flex"}
                      gap={1}
                      flexWrap={"wrap"}
                      alignItems={"flex-start"}
                    >
                      <Box height={"fit-content"}>
                        <Link
                          to={`/products?versionName=${product?.Versions?.name}&tab=1`}
                        >
                          <Chip
                            label={product?.Versions?.name}
                            sx={{ "&: hover": { background: "lightgray" } }}
                          />
                        </Link>
                      </Box>
                      <Box height={"fit-content"}>
                        <Link
                          to={`/products?originName=${product?.Origin?.name}&tab=1`}
                        >
                          <Chip
                            label={product?.Origin?.name}
                            sx={{ "&: hover": { background: "lightgray" } }}
                          />
                        </Link>
                      </Box>
                      <Box height={"fit-content"}>
                        <Link
                          to={`/products?productTypeName=${product?.ProductType?.name}&tab=1`}
                        >
                          <Chip
                            label={product?.ProductType?.name}
                            sx={{ "&: hover": { background: "lightgray" } }}
                          />
                        </Link>
                      </Box>
                    </Box>
                  </Paper>
                </Box>

                <CarrouselWith4cards
                  sectionList={product?.relatedOrigins?.products}
                  greyTitle=""
                  purpleSubTitle={`Confira os produtos mais procurados da origem ${product?.originName}`}
                  vermais={`originName=${product?.originName}`}
                />

                <CarrouselWith4cards
                  sectionList={product?.relatedProductTypes?.products}
                  greyTitle=""
                  purpleSubTitle={`Confira os produtos mais procurados do tipo ${product?.productTypeName}`}
                  vermais={`productTypeName=${product?.productTypeName}`}
                />
                <CarrouselWith4cards
                  sectionList={product?.relatedVersions?.products}
                  greyTitle=""
                  purpleSubTitle={`Confira os produtos mais procurados da versão ${product?.versionName}`}
                  vermais={`versionName=${product?.versionName}`}
                />
              </Box>
            ) : (
              <NoData text="No product found" />
            )}
          </Box>
        </FadeInContainer>
      </Paper>
    </Box>
  );
}
